// src/components/notary-open.js

import React, { useState, Fragment, useEffect } from 'react';
import { RestHelper } from '../helper/restHelper'
import { NotaryViewOpenRequest } from '../components'



const NotaryOpen = (profileEmail) => {
  const [message, setApiRes] = useState([])
  const [viewState, setViewState] = useState(false)
  const [viewRequest, setViewRequest] = useState(false)
  const [requestId, setRequestId] = useState('')
  const [dataFetched, setDataFetched] = useState(true)
  const [passedData, setPassedData] = useState({
    requestId : '',
    profileEmail : ''
  })


  const activeUser = {'activeUser': profileEmail.profileEmail }
  const action = {'action': 'Open' }
 
  const api = RestHelper()
 
  useEffect (() => {
    changeView();
  }, []);

  // if Check Pending Requests is selected, we'll query for pending requests

  const scanBackCheck = (checkFlag) => {
    var scanBackValue = ''
    if (checkFlag === 'true') {
      scanBackValue = 'SCAN BACKS ARE REQUIRED'
    }
    else{
      scanBackValue = 'NONE'
    }
    return scanBackValue

  }

  const dateFormat = (inputDate) => {
    const dateArray = inputDate.split("-")
    const date = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0]
    return date
  }
  const changeView = () => {
    if (viewState){
        setViewState(false);
        setViewRequest(false)
        setDataFetched(false)
        setApiRes([])
    }
    else{
    setViewState(true);
    setViewRequest(false)
    const options = {}
    if(dataFetched){
        api
            .postCreate('/get-notary-open-requests', options, action)
            .then(res => setApiRes(res))
            .catch(err => console.log(err))
        }
        setDataFetched(true)
    }
  }

  const getRequest = (data) => {
    setRequestId(data.RequestId)
    setPassedData({ ...passedData, requestId: requestId, profileEmail: profileEmail.profileEmail })
    setViewRequest(true);
    setViewState(false)
  }
  

  return(
    <div>
  {viewRequest
    ? (<div className='container mb-3 border rounded bg-white'>
        <div className='row rounded bg-white'>
            <button className="close ml-3 mb-2 mt-2" aria-label="Close" onClick={() =>changeView()}>
                <span aria-hidden='false'>&times;</span>
            </button>
        </div>
        <Fragment>
            <NotaryViewOpenRequest requestId={requestId} profile={profileEmail.profileEmail} status='open'/>
         </Fragment>
        </div>)
    : <div></div>
    }
  {viewState && (
        <div className="mt-5 mb-3">
          <h6 className="muted">Currently open requests:</h6>
          <div className="container-fluid rounded">
            <div className="card mx-2">
                <div className="card-body">
                    {message.map((items =>
                         <div className='container bg-light rounded border mb-2'>
                         <button className='btn btn-secondary mt-3 mb-2 rounded' type='button' onClick={() => getRequest(items)}>Click Here to Review and Claim</button>
                         <div className="row">
                            <div className="col">
                                <h6 className="card-text">Appointment Name:</h6>
                            </div>
                            <div className="col">
                                <p className="card-text">{items.Appt_Name}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h6 className="card-text">Status:</h6>
                            </div>
                            <div className="col">
                                <p className="card-text">{items.Status}</p>
                            </div>
                        </div>
                        <div className="row">
                        <div className="col">
                                <h6 className="card-text">File Number:</h6>
                            </div>
                            <div className="col">
                                <p className="card-text">{items.fileNumber}</p>
                            </div>
                        </div>
                        <div className="row">
                          <div className="col">
                                <h6 className="card-text">Location:</h6>
                            </div>
                            <div className="col">
                                <p className="card-text">{items.Appt_City}, {items.Appt_State}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h6 classname="card-text">Date:</h6>
                            </div>
                            <div className="col">
                                <p className="card-text">{dateFormat(items.Appt_Date)}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h6 classname="card-text">Time:</h6>
                            </div>
                            <div className="col">
                                <p className="card-text">{items.Appt_Time} {items.Appt_TimeZone}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h6 classname="card-text">Signing Agent Fee:</h6>
                            </div>
                            <div className="col">
                                 <p className="card-text">${items.Appt_Offer}</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <h6 classname="card-text">Scan Backs:</h6>
                            </div>
                            <div className="col">
                                 <p className="card-text">{scanBackCheck(items.scanBack)}</p>
                            </div>
                        </div>
                         </div>
                    ))}    
                </div>
            </div>
          </div>
        </div>
      )}
</div>
  )
};

export default NotaryOpen;